import { useTranslation } from "react-i18next"
import { StatusPill, toneOfColor } from "../ui/status-pill"

/** Order status -> Mantine palette name. The dot and the pale background share it; the word carries the meaning. */
const STATUS_COLOR: Record<string, string> = {
  DRAFT: "gray",
  REGISTERED: "blue",
  REVIEW_REJECTED: "gray",
  REVIEWED: "yellow",
  APPROVED: "green",
  AUTHORIZED: "green",
  REJECTED: "red",
  CANCELED: "gray",
  AUTO_CANCELED: "gray",
  PREPARING: "orange",
  DELIVERING: "orange",
  DELIVERED: "green",
  CLOSED: "green",
}

type Props = {
  code: string | null | undefined
  /** «received»: the supplier's view of a PO, where REVIEWED reads «Ирсэн» (BE receivedName). */
  perspective?: "sent" | "received"
}

/** Dot + word on a pale background for any palette colour (customer status, delivery state, ...). */
export function DotTag({ color, label }: { color: string; label: string }) {
  return <StatusPill tone={toneOfColor(color)}>{label}</StatusPill>
}

/** Translated order status as a dot + word on a pale background (Std status text, O77). Empty value is «-». */
export function OrderStatusTag({ code, perspective = "sent" }: Props) {
  const { t } = useTranslation("order")
  if (!code) return <>-</>
  const color = STATUS_COLOR[code] ?? "gray"
  const key = perspective === "received" && code === "REVIEWED" ? "orderStatusReceived.REVIEWED" : `orderStatus.${code}`
  return <DotTag color={color} label={t(key, { defaultValue: code })} />
}
